module.exports = __webpack_public_path__ + "img/ml3046.be965385.png";